import { FormErrors } from 'redux-form';
import { Nullable } from '@Models';

const validate = (
  values: NinthAgeUnitV2MakeParams,
): FormErrors<NinthAgeUnitV2MakeParams> => {
  const errors: FormErrors<NinthAgeUnitV2MakeParams> = {};

  // if (!values.size || values.size <= 0) {
  //   errors.size = 'tool.pairing.form.size.error';
  // }

  return errors;
};
export default validate;

export type NinthAgeUnitV2OptionMakeParams = {
  id: number;
  name: string;
  points: number;
};
export type NinthAgeUnitV2TroopMakeParams = {
  id: number;
  name: string;
  att: string;
  of: string;
  str: string;
  ap: string;
  agi: string;
};
export type NinthAgeUnitV2CaracMakeParams = {
  adv: string;
  mar: string;
  dis: string;
  evoked: Nullable<string>;
  hp: string;
  def: string;
  res: string;
  arm: string;
  aeg: string;
  fly: NinthAgeUnitV2CaracFlyMakeParams;
};
export type NinthAgeUnitV2CaracFlyMakeParams = {
  adv: string;
  mar: string;
};

export type NinthAgeUnitV2MakeParams = {
  points: number;
  addPoints: number;

  sizeMin: number;
  sizeMax: number;

  carac: NinthAgeUnitV2CaracMakeParams;

  troops: NinthAgeUnitV2TroopMakeParams[];

  magics: NinthAgeUnitV2OptionMakeParams[];
  options: NinthAgeUnitV2OptionMakeParams[];
  mounts: NinthAgeUnitV2OptionMakeParams[];
};
